import {
  faExclamation,
  faPlus,
  faTimes,
  faUndo,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  Col,
  Input,
  Label,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import withRedirect from "../../helpers/hoc/withRedirect";
import ButtonIcon from "../common/ButtonIcon";
import FalconCardHeader from "../common/FalconCardHeader";
import Flex from "../common/Flex";
import Datetime from "react-datetime";
import ComposeAttachment from "../complain/ComposeAttachment";
import { Toast } from "../UI/toast/Toast";
import { postSurvey } from "../../helpers/api/survey";
import { useSelector } from "react-redux";
import { createPost } from "../../helpers/api/post";
import {
  isIterableArray,
  Message,
  Or,
  PreloadState,
} from "../UI/preloading/PreloadState";


const CreateSurveys = ({ setRedirect, setRedirectUrl }) => {
  const history = useHistory();
  const { survey } = useParams();
  const { selectedCondominium } = useSelector((state) => state.condominium);

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [options, setOptions] = useState([]);
  const [dueDate, setDueDate] = useState(null);
  const [tempOption, setTempOption] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [filess, setFiles] = useState([]);
  const [isDisabled, setIsDisabled] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  /*   const [file, setFile] = useState([]); */

  const handleAddAttachment = (files) => {
    if (files.length === 0) return;
    const { name, size, type } = files[0];
    const newFile = {
      id: attachments.length + 1 + Date.now(),
      name,
      size,
      type,
    };
    setFiles([...filess, files[0]]);
    /*     setFile([...file, files[0]]); */
    setAttachments([...attachments, newFile]);
  };

  const handleDetachAttachment = (id, index) => {
    setAttachments(attachments.filter((attachment) => id !== attachment.id));
    setFiles(filess.filter((file, i) => i !== index));
  };

  useEffect(() => {
    setIsDisabled(!description || !title || options.length === 0 || !dueDate);
  }, [description, title, options, dueDate]);

  const saveInteraction = async () => {
    if (filess.length > 0) {
      setSubmitting(true);
      const formdata = new FormData();
      formdata.append("title", title);
      formdata.append("survey", survey);
      formdata.append("details", description);
      formdata.append("due_date", dueDate.format("YYYY-MM-DD"));

      options.map((option, i) => formdata.append(`options[${i}]`, option));
      filess.map((file, i) => formdata.append(`files[${i}]`, file));

      postSurvey(selectedCondominium, formdata)
        .then(({ code }) => {
          if (code === SUCCESS_RESPONSE.CREATED) {
            const fd = new FormData();
            fd.append("condominium", selectedCondominium);
            fd.append(
              "title",
              survey === "1"
                ? "¡Nueva encuesta disponible en el condominio!"
                : "¡Nueva votación disponible en el condominio!"
            );
            fd.append(
              "description",
              `<h5><b>${title}</b></h5<br/><br/> Ve a la sección de <a href="/dashboard/surveys">Encuestas/Votaciones</a> para responderla.`
            );
            createPost(fd)
              .then(({ code }) => {
                if (code === SUCCESS_RESPONSE.CREATED)
                  Toast.fire({
                    type: "success",
                    title: `Se ha realizado la ${
                      survey === "1" ? "Encuesta" : "Votación"
                    } exitosamente, también se ha publicado en el muro, para informar a los propietarios.`,
                  });
                history.goBack();
              })
              .catch((error) => handleErrorMessage(error))
              .finally(() => setSubmitting(false));
          }
        })
        .catch((error) => {
          handleErrorMessage(error);
          console.log(error);
        });
    }
    if (filess.length === 0) {
      setSubmitting(true);
      const formdata = new FormData();
      formdata.append("title", title);
      formdata.append("survey", survey);
      formdata.append("details", description);
      formdata.append("due_date", dueDate.format("YYYY-MM-DD"));

      options.map((option, i) => formdata.append(`options[${i}]`, option));
      /*  filess.map((file, i) => formdata.append(`files[${i}]`, `https://homelan.nyc3.digitaloceanspaces.com/${file.name}`)); */

      postSurvey(selectedCondominium, formdata)
        .then(({ code }) => {
          if (code === SUCCESS_RESPONSE.CREATED) {
            const fd = new FormData();
            fd.append("condominium", selectedCondominium);
            fd.append(
              "title",
              survey === "1"
                ? "¡Nueva encuesta disponible en el condominio!"
                : "¡Nueva votación disponible en el condominio!"
            );
            fd.append(
              "description",
              `<h5><b>${title}</b></h5<br/><br/> Ve a la sección de <a href="/dashboard/surveys">Encuestas/Votaciones</a> para responderla.`
            );
            createPost(fd)
              .then(({ code }) => {
                if (code === SUCCESS_RESPONSE.CREATED)
                  Toast.fire({
                    type: "success",
                    title: `Se ha realizado la ${
                      survey === "1" ? "Encuesta" : "Votación"
                    } exitosamente, también se ha publicado en el muro, para informar a los propietarios.`,
                  });
                history.goBack();
              })
              .catch((error) => handleErrorMessage(error))
              .finally(() => setSubmitting(false));
          }
        })
        .catch((error) => {
          handleErrorMessage(error);
          console.log(error);
        });
    }
  };

  return (
    <>
      <Card>
        <FalconCardHeader
          title={
            survey === "1" ? "Creación de encuesta" : "Creación de votación"
          }
        />
        <PreloadState
          loading={submitting}
          message="Publicando por favor espere..."
        >
          <CardBody className="p-0">
            <div className="border-bottom border-200">
              <Input
                type="text"
                className="border-0 outline-none px-card"
                value={title}
                onChange={({ target }) => setTitle(target.value)}
                placeholder="Título"
              />
            </div>
            <div className="border-bottom border-200">
              <Input
                type="text"
                className="border-0 outline-none px-card"
                value={description}
                onChange={({ target }) => setDescription(target.value)}
                placeholder="Descripción"
              />
            </div>
            <div>
              <Flex className="align-items-center border-bottom border-200">
                <Input
                  placeholder="Escriba una opción"
                  type="text"
                  className="border-0 outline-none px-card border-bottom"
                  value={tempOption}
                  onChange={({ target }) => setTempOption(target.value)}
                />
                <ButtonIcon
                  className="shadow-none"
                  icon={faPlus}
                  disabled={!tempOption}
                  style={{ whiteSpace: "nowrap" }}
                  size="md"
                  color="falcon-default"
                  onClick={() => {
                    setOptions((prev) => [...prev, tempOption]);
                    setTempOption("");
                  }}
                >
                  Agregar opción
                </ButtonIcon>
              </Flex>
            </div>
            <Row className="border-bottom border-200 px-3 py-3">
              <Col xs={12}>
                <Label className="ml-2 ">Opciones:</Label>
              </Col>
              <Or cond={isIterableArray(options)}>
                <Or value={options.length > 1}>
                  <Col xs={12}>
                    {options.map((val, i) => {
                      return (
                        <div key={i}>
                          {i !== 0 && (
                            <hr key={`hr-${i}`} className="p-0 m-0" />
                          )}
                          <span className="text-muted">
                            <Button
                              color="falcon-default"
                              className="shadow-none"
                              onClick={() => {
                                setOptions(
                                  options.filter((_, index) => i !== index)
                                );
                              }}
                            >
                              <FontAwesomeIcon icon={faTimes} />
                            </Button>{" "}
                            {val}
                          </span>
                        </div>
                      );
                    })}
                  </Col>
                </Or>
                <Or value={options.length <= 1}>
                  <Col xs={12}>
                    <Message
                      color={"warning"}
                      value={false}
                      icon={faExclamation}
                      className="m-2 pb-3"
                    >
                      Asegúrese de registrar al menos dos opciones.
                    </Message>
                  </Col>
                </Or>
              </Or>
            </Row>
            <div className="border-bottom border-200 pt-3">
              <Label className="ml-4">Fecha de expiración</Label>
              <Datetime
                className="border-0 outline-none px-card border-bottom mb-2"
                timeFormat={false}
                dateFormat="DD/MM/YYYY"
                isValidDate={(current, selected) => {
                  return current.isAfter();
                }}
                value={dueDate}
                onChange={(value) => {
                  setDueDate(value);
                }}
              />
            </div>

            <Row className="px-3 pt-3">
              <Col xs={12}>
                <Label className="ml-2 ">Archivos adjuntos:</Label>
              </Col>
              <Or cond={isIterableArray(attachments)}>
                <Or value={true}>
                  <Col xs={12}>
                    {attachments.map((attachment, i) => (
                      <ComposeAttachment
                        {...attachment}
                        key={attachment.id}
                        index={i}
                        handleDetachAttachment={handleDetachAttachment}
                      />
                    ))}
                  </Col>
                </Or>
                <Col xs={12}>
                  <Message
                    color={"warning"}
                    value={false}
                    icon={faExclamation}
                    className="m-2 pb-3"
                  >
                    No hay archivos adjuntos para mostrar
                  </Message>
                </Col>
              </Or>
            </Row>
          </CardBody>
          <CardFooter>
            <Row>
              <Col className="d-flex justify-content-end pt-3">
                <Label
                  for="email-attachment"
                  className="ml-auto mr-2 btn btn-falcon-default m-0 cursor-pointer"
                  id="AttachFiles"
                >
                  <FontAwesomeIcon icon="paperclip" className="fs-1" />
                </Label>
                <Input
                  className="d-none"
                  id="email-attachment"
                  type="file"
                  onChange={({ target }) => handleAddAttachment(target.files)}
                />
                <UncontrolledTooltip placement="top" target="AttachFiles">
                  Adjuntar archivos
                </UncontrolledTooltip>
                <ButtonIcon
                  color="falcon-default"
                  className="px-5 mr-2"
                  icon={faUndo}
                  onClick={() => history.push("/dashboard/surveys")}
                  iconAlign="right"
                  size="md"
                  transform="down-1 shrink-4"
                >
                  Volver
                </ButtonIcon>
                <ButtonIcon
                  data-testid="submit-button"
                  color="primary"
                  className="px-5 ml-2"
                  type="button"
                  icon="save"
                  size="md"
                  iconAlign="right"
                  disabled={isDisabled}
                  transform="down-1 shrink-4"
                  onClick={saveInteraction}
                >
                  Guardar {survey === "1" ? "encuesta" : "votación"}
                </ButtonIcon>
              </Col>
            </Row>
          </CardFooter>
        </PreloadState>
      </Card>
    </>
  );
};

export default withRedirect(CreateSurveys);
